import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '../../../../../components/common/Typography';
import Button from '../../../../../components/common/Button';

import TextField from '../../../../../components/common/TextField';

import CheckBoxWithArrow from '../../../../../components/CheckBoxWithArrow';
import { kakaoTossSelectItem, personalInfoInputList } from '../../../../../common/data';
import { getAlertMessageFunction, getRegNumber08 } from '../../../../../common/Util';
import { isValidateKakao, kakaoErrorHandler } from '../../../util';
import AlertContext from '../../../../../context/AlertContext';
import { getTossToken, kakaoCertPrepare, tossCertPrepare } from '../../../resultQuerySlice';
import { sendCertRequest } from '../../../../eDocuments/eDocumentsSlice';

const Step1 = ({
  stepHandler,
  selectedItem,
  setSelectedItem,
  setKakaoData,
  check,
  setCheck,
  modalCloseHandler,
}) => {
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);

  const { t } = useTranslation('eDocuments');
  const { t: tResult } = useTranslation('resultQuery');
  const { t: tCommon } = useTranslation('common');
  const inputList = personalInfoInputList(tCommon);
  const kakaoTossSelectItemList = kakaoTossSelectItem(t).slice(0, 2);
  const { tossToken } = useSelector(state => state.resultQuery);
  const [form, setForm] = useState({
    htmInsaPerNm: '',
    htmPerBirth: '',
    htmInsaPerHTel: '',
  });

  const { myInfo } = useSelector(state => state.myInfo);
  useEffect(() => {
    if (myInfo) {
      let birth = getRegNumber08(myInfo.htmPerRegNum);

      console.log('birth>>', birth);
      console.log('myInfo>>', myInfo);
      setForm({
        htmInsaPerNm: myInfo.htmInsaPerNm || '',
        htmPerBirth: birth,
        htmInsaPerHTel: myInfo.htmInsaPerHTel?.replace(/-/g, '').trim(),
      });
    }
  }, [myInfo]);

  // 토스토큰발급
  useEffect(() => {
    dispatch(getTossToken());
  }, []);

  const handleChange = e => {
    let { name, value } = e.target;
    if (name == 'htmPerBirth' || name == 'htmInsaPerHTel') {
      value = value.replace(/[^0-9]/g, '');
    }

    setForm({ ...form, [name]: value });
  };

  const handleSelectItem = value => {
    setSelectedItem(value);
  };

  const onClickButton = () => {
    if (!selectedItem) {
      //간편인증을 먼저 선택해주세요.
      alertMessage(t('linkToData.step2.alertMessage01'));
      return;
    }

    const validation = isValidateKakao(check, form);
    if (!validation.isValid) {
      alertMessage(tCommon(validation.messageKey));
      return;
    }

    certPrepareAPI();
  };

  const certPrepareAPI = async () => {
    try {
      //카카오 params
      let params = {
        name: form.htmInsaPerNm,
        birthday: form.htmPerBirth,
        phone_no: form.htmInsaPerHTel,
        flag: 'ya',
      };
      let api = selectedItem == '0' ? kakaoCertPrepare : tossCertPrepare;

      //toss params
      if (selectedItem === '1') {
        params = {
          userName: form.htmInsaPerNm,
          userPhone: form.htmInsaPerHTel,
          userBirthday: form.htmPerBirth,
          access_token: tossToken,
          flag: 'ya',
        };
      }

      const response = await dispatch(api(params)).unwrap();
      const { resultCode, resultData, resultError } = response;
      console.log('response >>', response);

      //토큰 만료(토스)
      if (resultCode == '-2') {
        alertMessage(tCommon('alertMessage.alertMessage18'));
        modalCloseHandler();
        return;
      }

      if (resultError) {
        alertMessage(tCommon(kakaoErrorHandler(resultError)));
        return;
      }

      if (resultCode == '1') {
        console.log('resultData >>', resultData);
        setKakaoData(resultData);
        stepHandler(3);
      }
    } catch (error) {}
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        {/* 간편인증을 먼저 선택해 주세요! */}
        <Typography variant="body1Bold">{t('linkToData.description1')}</Typography>
        {/* 개인정보 내용을 다시 한번 확인해 주세요. */}
        <Typography variant="body1Medium">{tResult('kakaoModal.title')}</Typography>
      </div>
      {/* 카카오 토스 선택 */}
      <div style={{ display: 'flex', gap: '24px', alignItems: 'center', justifyContent: 'center' }}>
        {kakaoTossSelectItemList.map((item, index) => (
          <div
            key={index}
            onClick={() => handleSelectItem(item.value)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px',
            }}>
            <img
              src={item.icon}
              alt="kakao_icon"
              style={{
                width: '50px',
                height: '50px',
                border: `${selectedItem === item.value ? '2px solid var(--Support-Pink)' : 'none'}`,
                boxShadow: `${
                  selectedItem === item.value ? '0px 0px 15px 0px rgba(254, 84, 147, 0.30)' : 'none'
                }`,
                borderRadius: '12px',
              }}
            />
            <Typography className="captionMedium">{item.label}</Typography>
          </div>
        ))}
      </div>

      {/* input 입력 */}
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {inputList.map(input => (
          <TextField
            size="small"
            key={input.key}
            label={input.label}
            value={form[input.key] || ''}
            name={input.key}
            onChange={handleChange}
            disabled
          />
        ))}
      </div>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {/* 개인정보 이용 동의(필수) */}
        <CheckBoxWithArrow
          clickCheckHandler={() => stepHandler(2)}
          check={check}
          handleCheckChange={() => setCheck(!check)}
          label={tResult('kakaoModal.checkBoxLabel')}
        />
      </div>
      <div className="stepButtonContainer">
        <Button value={t('linkToData.button1')} fullWidth onClick={onClickButton} />
      </div>
    </div>
  );
};

export default Step1;
